import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: theme.spacing(55.875),
    height: theme.spacing(23.75),
    [theme.breakpoints.down('sm')]: {
      top: '50%',
      width: '100%',
    },
  },
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
  header: {
    textAlign: 'center',
    marginTop: theme.spacing(2),
  },
  cardholder: {
    marginLeft: theme.spacing(4.75),
    marginRight: theme.spacing(3.5),
    marginTop: theme.spacing(-1.875),
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(3),
    },
  },
  controls: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
    justifyContent: 'center',
    marginLeft: theme.spacing(7.5),
    marginRight: theme.spacing(6),
    marginBottom: theme.spacing(1),
  },
  buttonList: {
    display: 'flex',
    justifyContent: 'space-around',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
    },
  },
  button: {
    marginLeft: theme.spacing(2),
    height: theme.spacing(5.25),
    width: theme.spacing(16),
  },
}));

const CardholderModal = ({
  cardholder: { id, firstName, lastName, title, photo },
  updateCardholder,
}) => {
  const classes = useStyles();

  const onYesClick = async () => {
    await updateCardholder();
    document.location.href = `/cardholders`;
  };

  const iconclick = () => {
    document.location.href = `/cardholders`;
  };

  return (
    <Paper className={classes.paper} square>
      <div className={classes.container}>
        <h2 className={classes.header}>Do you want to save changes?</h2>
        <Typography className={classes.cardholder} />
        <div className={classes.controls}>
          <div className={classes.buttonList}>
            <Button
              className={classes.button}
              variant="text"
              style={{ color: '#707070', height: '40px', width: '110px' }}
              onClick={() => iconclick()}
            >
              Cancel
            </Button>
            <Button
              className={classes.button}
              variant="contained"
              style={{ backgroundColor: '#5ba9e1', color: '#fff', height: '40px', width: '110px' }}
              onClick={() => onYesClick()}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </Paper>
  );
};

export default CardholderModal;
